export default __webpack_public_path__ + "static/media/DoncasterSameDayEmergencyCare(SDEC)-MedicalSDECcriteria.8a9c7ab2.jpg";